var React = require('react');

function Person (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"clip-path"},React.createElement("rect",{"width":"14.33","height":"13.749","fill":"none"}))),React.createElement("g",{"id":"Grille_de_répétition_6","data-name":"Grille de répétition 6","clipPath":"url(#clip-path)","key":1},React.createElement("g",{"transform":"translate(-1532 -2561.501)"},React.createElement("path",{"id":"Icon_ionic-md-people","data-name":"Icon ionic-md-people","d":"M13.916,10.739ZM9.055,13.6a2.865,2.865,0,1,0-2.916-2.864A2.9,2.9,0,0,0,9.055,13.6Zm0,2.1c-2.285,0-6.805,1.1-6.805,3.342v2.578H16V19.046C16,16.8,11.34,15.7,9.055,15.7ZM16,16.277C17.117,17.089,16.339,16.229,16,16.277Z","transform":"translate(1529.75 2553.626)","fill":"#fff"})))]);
}

Person.defaultProps = {"width":"14.33","height":"13.749","viewBox":"0 0 14.33 13.749"};

module.exports = Person;

Person.default = Person;
